<template>
  <div class="profile_bg">
    <div v-if="dadosPaciente">
      <profile />
    </div>
  </div>
</template>

<script>
import Profile from '../profile/Profile'
import { mapGetters } from 'vuex'

export default {
  name: 'IntroHeader',
  components: { Profile },
  computed: {
    ...mapGetters({
      dadosPaciente: 'dadosPaciente'
    })
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/styleguide';

* {
  margin-bottom: 1.875rem;
}

.profile_bg {
  padding-top: 10.625rem;
  height: 19.375rem;
  background: url('~@/assets/images/bg_home.jpg') no-repeat center center;
  background-size: cover;

  div {
    margin: 0 auto;
    position: relative;
    max-width: 70rem;
    width: 100%;
  }
}

.highcontrast-active .profile_bg {
  background-color: var(--black);
}

@media (max-width: 64rem) {
  .profile_bg {
    padding-top: 6.5rem;
    height: auto;
    padding-bottom: 0.2rem;
  }
}
</style>
